export default __webpack_public_path__ + "static/media/title_s.28b27ef4.jpg";